module.exports = __webpack_public_path__ + "static/media/Googleplay.95e261bc.svg";